import type { PipeIntegration, PipeIntegrationDef } from '../index'

/**
 * CHECKOUT carries configuration, not behaviour: one row holds the payment
 * checkout's settings for every pipe it reaches, one part per provider
 * (`CheckoutIntegrationConfig` in checkoutSdkVersion.ts, validated by
 * `CheckoutIntegrationConfigDto` on the API).
 *
 * So this module is deliberately empty. The build hands each provider's part to
 * the PRIMER / YUNO pre-warm integration that the pipe's own checkout activates
 * (builder/lib/pages.ts getActiveIntegrations) — a row never decides whether a
 * checkout runs. Runtime code that needs the settings reads them through
 * `pipe.getIntegrationConfig('CHECKOUT')`.
 */
const checkoutIntegration: PipeIntegration = (): PipeIntegrationDef => ({})

export default checkoutIntegration
